import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import EditCarouselModal from '../../Modals/Carousel/EditCarouselModal';
import ContentSearchModal from 'appSrc/AdminPanel/components/ContentSearchModal';
import ProductSearchModal from '../../Modals/ProductSearch/index.js';
import { PrimaryButton } from 'appSrc/components/UI';
import SortableContentsTable from './ContentsTable';
import { push } from 'connected-react-router';
import style from './styles/style.module.css';

class IndividualCarouselPage extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            fetching: true,
            carousel: {},
            editing: false,
            addingArticle: false,
            addingProduct: false,
        };

        this.loadCarousel( this.props.match.params.id );
    }
    loadCarousel = ( id ) => {
        this.props.getCarousel( id )
        .then( ( carousel ) => {
            this.setState( {
                fetching: false,
                carousel: carousel,
            } );
        } );
    }
    openEditModal = () => {
        this.setState( { editing: true } );
    }
    onEditSubmit = ( carousel ) => {
        if ( !carousel ) {
            // redirect to carousel list page after 'delete' operation
            this.props.redirect( '/admin/carousels' );
        } else {
            this.setState( { carousel: carousel, editing: false } );
        }
    }
    onEditClose = () => {
        this.setState( { editing: false } );
    }

    openArticleModal = () => {
        this.setState( { addingArticle: true } );
    }
    openProductModal = () => {
        this.setState( { addingProduct: true } );
    }
    closeModals = () => {
        this.setState( { addingArticle: false, addingProduct: false } );
    }
    
    getContentsForUpdate = () => {
        const { carousel } = this.state;

        // include articles in contents
        let content = carousel.curated_articles.map( ( article ) => {
            return {
                type: 'curated_article',
                id: article.id,
                content_order: article.articles_carousels.content_order,
            };
        } );

        let desires = carousel.desires.map( ( product ) => {
            return {
                type: 'desire',
                id: product.desireid,
                content_order: product.desires_carousels.content_order,
            };
        } );

        let contents = content.concat(desires);

        // sort contents by content_order
        contents.sort( ( a, b ) => {
            return ( a.content_order < b.content_order ) ? -1 : 1;
        } );

        return contents;
    }
    getContentsForDisplay = () => {
        const { carousel } = this.state;

        // include content and products in contents
        let content = carousel.curated_articles.map( ( article ) => {
            return {
                ...article,
                type: 'curated_article',
                content_order: article.articles_carousels.content_order,
            };
        } );

        let products = carousel.desires.map( ( product ) => {
            return {
                ...product,
                type: 'product',
                content_order: product.desires_carousels.content_order,
            };
        } ); 

        let contents = content.concat(products);

        // sort contents by content_order
        contents.sort( ( a, b ) => {
            return ( a.content_order < b.content_order ) ? -1 : 1;
        } );

        return contents;
    }
    addArticle = ( article ) => {
        let contents = this.getContentsForUpdate();
        contents.push({
            type: 'curated_article',
            id: article.id,
        });
        this.props.updateCarousel( this.state.carousel.id, { contents } )
        .then( () => {
            this.loadCarousel( this.props.match.params.id );
        } );
    }
    removeContent = ( index ) => {
        let contents = this.getContentsForUpdate();
        contents.splice( index, 1 );
        this.props.updateCarousel( this.state.carousel.id, { contents } )
        .then( () => {
            this.loadCarousel( this.props.match.params.id );
        } );
    }
    onManualContentSort = ( order, sortable, evt ) => {
        // reorder contents
        let contents = this.getContentsForUpdate();
        let movedItem = contents.splice( evt.oldIndex, 1 )[ 0 ];
        contents.splice( evt.newIndex, 0, movedItem );

        // update content order
        this.props.updateCarousel( this.state.carousel.id, { contents } )
        .then( () => {
            this.loadCarousel( this.props.match.params.id );
        } );
    }
    addProduct = ( product ) => {
        let contents = this.getContentsForUpdate();
        contents.push({
            type: 'desire',
            id: product.desireid,
        });
        this.props.updateCarousel( this.state.carousel.id, { contents } )
        .then( () => {
            this.loadCarousel( this.props.match.params.id );
        } );
    }

    render() {
        const { fetching, carousel } = this.state;

        if( fetching || !carousel ) {
            return (
                <section className={ style.individual }>
                    <LoadingReplace />
                </section>
            );
        }

        const contents = this.getContentsForDisplay();
        return (
            <section className={ style.individual }>
                <div className={ style.head }>
                    <div className={ style.controls }>
                        <div className={ style.backLink } onClick={ this.props.history.goBack }>Back</div>
                        <div>
                            <PrimaryButton label='Edit Carousel' onClick={ this.openEditModal } style={ { marginRight: '15px' } } />
                            <PrimaryButton label='Add Content' onClick={ this.openArticleModal } style={ { marginRight: '15px' } } />
                            <PrimaryButton label='Add Product' onClick={ this.openProductModal } style={ { marginRight: '15px' } } />
                        </div>
                    </div>
                    <div className={ style.individualDetails }>
                        <div>
                            <div className={ style.title }>
                                <h2 style={ { marginRight: '15px' } }>{ carousel.title }</h2>
                            </div>
                            <div className={ style.linkUrl }>
                                <p>
                                    <span className={ style.label }>Link:</span>
                                    { carousel.link_url &&
                                        <a href={ carousel.link_url } target='_blank' rel='noopener noreferrer'>{ carousel.link_text || 'See All' }</a>
                                    }
                                </p>
                            </div>
                            <div className={ style.context }>
                                <p>
                                    <span className={ style.label }>Page:</span>
                                    { carousel.context }
                                </p>
                            </div>
                            <div className={ style.contextOrder }>
                                <p>
                                    <span className={ style.label }>Page Order:</span>
                                    { carousel.context_order }
                                </p>
                            </div>
                            <div className={ style.ui_type }>
                                <p>
                                    <span className={ style.label }>UI Type:</span>
                                    { carousel.ui_type }
                                </p>
                            </div>
                            <div className={ style.status }>
                                <p>
                                    <span className={ style.label }>Status:</span>
                                    { carousel.status }
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={ style.tabs }>
                        <div className={ style.tabOption }
                        data-active={ true }>
                            Contents ({ contents.length })
                        </div>
                    </div>
                </div>
                <div className={ style.body }>
                    { fetching ?
                        <LoadingReplace />
                        :
                        <SortableContentsTable contents={ contents }
                        removeContent={ this.removeContent }
                        onSort={ this.onManualContentSort } />
                    }
                </div>
                { this.state.editing &&
                    <EditCarouselModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    carousel={ carousel } />
                }
                { this.state.addingArticle &&
                    <ContentSearchModal closeModal={ this.closeModals }
                    onSubmit={ this.addArticle } existingContent={ carousel.curated_articles } />
                }
                { this.state.addingProduct &&
                    <ProductSearchModal closeModal={ this.closeModals }
                    onSubmit={ this.addProduct } markedProducts={ carousel.desires || [] } />
                }
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        getCarousel: ( id ) => {
            return dAPI.get( `/admin/curated-carousels/${ id }` );
        },
        updateCarousel: ( id, data ) => {
            return dAPI.patch( `/admin/curated-carousels/${ id }`, data );
        },
        redirect: ( url ) => {
            dispatch( push( url ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( IndividualCarouselPage );
